import React, {useEffect, useState} from 'react';
import {getSharedChat} from "../API/KB/KBAPI.js";
import {ChatMessages} from "./ChatMessages.js";
import {Box, Button, Container} from "@mui/material";
import {ChatAvatarBackground} from "./ChatAvatarBackground.js";
import {colorPaper} from "../App/theme.js";


export const ShareChat = ({kbId, shareId}) => {
    const [messages, setMessage] = useState(null);
    const [avatars, setAvatars] = useState(null);

    useEffect(() => {
        document.body.style.backgroundColor = colorPaper;
        return () => document.body.style.backgroundColor = ''
    }, []);

    useEffect(() => {
        getSharedChat(kbId, shareId).then(data => {
            setMessage(data?.data?.messagesToShare);
            setAvatars(data?.data?.avatars);
        })
    }, []);

    const containerStyle = {
        width: '80%',
        minHeight: '100vh', // Ensure the container takes the full viewport height
        backgroundColor: colorPaper
    };

    const chatContainerStyle = {
        marginTop: 10,
        marginLeft: -40,
        marginRight: -40,
        backgroundColor: colorPaper
    };

    const signupButtonStyle = {
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 1000,
        opacity: 0.7
    };

    return (
        <Container style={containerStyle}>
            {/* Signup Button */}
            <Box style={signupButtonStyle}>
                <Button
                    variant="contained"
                    color="primary"
                    href="https://openkbs.com/signup"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Sign Up
                </Button>
            </Box>
            <Box mt={0} className="chat-container" ref={null} style={chatContainerStyle}>
                <ChatAvatarBackground kbId={kbId}/>
                {messages && <ChatMessages
                    sharedChat={{avatars}}
                    KBId={kbId}
                    messages={messages}
                    setMessages={setMessage}
                />}
            </Box>
        </Container>
    );
};
